import { jsonp } from '@ifeng/ui_base';

/* 点击更多，获取信息流 */
/* eslint-disable */
const apiBaseUrl = typeof apiUrl !== 'undefined' ? apiUrl : '/api'; // apiUrl为webpack注入的全局变量
/* eslint-enable */

export const getColumnInfo = async function getColumnInfo(
    id,
    time,
    size,
    columnId,
    dataTypeName = 'default',
    urlId = '_',
) {
    return await jsonp(
        `${apiBaseUrl}/_/getColumnInfo/${urlId}/${dataTypeName}/${id}/${time}/${size}/${columnId}/getColumnInfoCallback`,
        {
            jsonpCallback: 'getColumnInfoCallback',
        },
    );
};

// export const getLocNews = async function getLocNews(location) {
//     return await jsonp(
//         `${apiBaseUrl}/_/getColumnInfo/${urlId}/${dataTypeName}/${id}/${time}/${size}/${columnId}/getColumnInfoCallback`,
//         {
//             jsonpCallback: 'getColumnInfoCallback',
//         },
//     );
// };
